






 







document.addEventListener("DOMContentLoaded", () => {


// Parse product data JSON
    const customProDataEl=document.getElementById("custom_pro_data");
    if(!customProDataEl)return;        // ← guard: not on a PDP, nothing to do

const productData = JSON.parse(document.getElementById("custom_pro_data").textContent);
const body = document.body;
const currencySymbol = body.dataset.currsymbol || "$"; // fallback to $ if not set
const currencyCode = body.dataset.currcode || "AUD"; 



// Helper: get selected value from fieldset by data-optname
function getCleanValue(optName) {
  const legend = document.querySelector(`.option_name[data-optname="${optName}"]`);
  if (!legend) return null;

  const fieldset = legend.closest("fieldset");
  const checkedInput = fieldset?.querySelector("input[type='radio']:checked");
  if (!checkedInput) return null;

  let value = checkedInput.getAttribute("data-opvalue");
  if (!value) {
    const label = fieldset.querySelector(`label[for="${checkedInput.id}"] span:last-child`);
    value = label?.textContent.trim();
  }
  return value;
}

// Function to update prices
function updatePrices() {
  const selectedMedium = getCleanValue("Medium");
  const selectedFrame = getCleanValue("Frame");

  document.querySelectorAll('.option_name[data-optname="Size"]').forEach(sizeLegend => {
    const fieldset = sizeLegend.closest("fieldset");

    fieldset.querySelectorAll("input[type='radio']").forEach(input => {
      const sizeValue = input.getAttribute("data-opvalue")?.trim();

      const match = productData.variants.find(v =>
        v.option1.includes(sizeValue) &&
        v.option2.trim() === selectedMedium &&
        v.option3.trim() === selectedFrame
      );

      const label = fieldset.querySelector(`label[for="${input.id}"]`);
      const priceEl = label.querySelector(".span_prc");

      if (priceEl) {
        priceEl.textContent = match && match.price ? `${currencySymbol}${(match.price / 100).toFixed(2)}` : "Unavailable";
      }
    });
  });
}

// Initial update
updatePrices();

// Delegated listener for dynamically updated variant-picker
document.addEventListener("change", (e) => {
  if (!e.target.closest("variant-picker")) return; // only trigger for variant-picker

  // if (e.target.closest("variant-picker")) {
  //   // Prevent Shopify's script from scrolling to variant-picker
  //   const activeEl = document.activeElement;
  //   if (activeEl) {
  //     activeEl.scrollIntoView = function() {}; // disable scroll
  //   }
  // }
  
  updatePrices();
});


  });


/* ── CRO-11-STICKY-ATC-JS-START — sticky behaviour ── */
/* Tier 1 item #11/#12 — Mobile sticky ATC visibility + click-to-scroll-to-variant.
   v2 (2026-05-03):
     - Hides sticky when static ATC or footer is in viewport (IntersectionObservers)
     - On click, preventDefault + smooth-scroll to <variant-picker> instead of
       form submit (avoids "default A4 added" surprise on $110-$750 spread). */
(function() {
  if (!document || !window || !window.IntersectionObserver) return;

  function initVisibility() {
    if (window.innerWidth >= 768) return;
    var stickyBar = document.querySelector('product-sticky-bar, .product-sticky-bar');
    if (!stickyBar) return;

    var allBuyButtons = Array.prototype.slice.call(document.querySelectorAll('buy-buttons'));
    var staticAtc = allBuyButtons.filter(function(b) { return !stickyBar.contains(b); })[0];
    var footer = document.querySelector('.shopify-section--footer') || document.querySelector('footer');

    var atcVisible = false, footerVisible = false;
    function update() {
      stickyBar.classList.toggle('cro-hide-sticky', atcVisible || footerVisible);
    }
    if (staticAtc) {
      new IntersectionObserver(function(entries) {
        atcVisible = entries[0].isIntersecting; update();
      }, { threshold: 0.1 }).observe(staticAtc);
    }
    if (footer) {
      new IntersectionObserver(function(entries) {
        footerVisible = entries[0].isIntersecting; update();
      }, { threshold: 0 }).observe(footer);
    }
    update();
  }

  function initClickScroll() {
    document.addEventListener('click', function(e) {
      if (window.innerWidth >= 768) return;
      var sticky = e.target.closest && e.target.closest('product-sticky-bar, .product-sticky-bar');
      if (!sticky) return;
      var btn = e.target.closest && e.target.closest('button[type="submit"], button.cstm_add_to_cart');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var target = document.querySelector('variant-picker') || document.querySelector('.variant-picker') || document.querySelector('product-form');
      if (target && target.scrollIntoView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initVisibility(); initClickScroll(); });
  } else {
    initVisibility();
    initClickScroll();
  }
})();
/* ── CRO-11-STICKY-ATC-JS-END ── */













/* ── CRO-E-OVERLAY-V2-JS-START — PDP gallery overlay behaviour ── */
/* Tier 1 item E v2 (Path B). Wires up the cro-pdp-overlay snippet:
   - Slide counter listens to <scroll-carousel> carousel:select events
   - View in Room click → forward to hidden Blankwall #ar-button
   - Heart click → forward to hidden Klaviyo .kl-hub-favorites-widget
   - Heart state mirrored from Klaviyo via MutationObserver on its class */
(function() {
  function findFirstVisible(selector) {
    var els = document.querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) return els[i]; // return first
    return null;
  }

  function setupCounter(overlay) {
    var counter = overlay.querySelector('[data-cro-counter]');
    if (!counter) return;
    var carouselId = overlay.getAttribute('data-carousel-id');
    var carousel = document.getElementById(carouselId);
    if (!carousel) return;
    var totalEls = carousel.querySelectorAll('.product-gallery__media');
    var total = totalEls.length || 1;
    counter.textContent = '1 / ' + total;
    carousel.addEventListener('carousel:select', function(e) {
      var idx = (e.detail && typeof e.detail.index === 'number') ? e.detail.index + 1 : 1;
      counter.textContent = idx + ' / ' + total;
    });
  }

  function setupVir(overlay) {
    var visibleBtn = overlay.querySelector('[data-cro-vir]');
    if (!visibleBtn) return;
    var arBtn = null;
    function findAr() {
      // First instance only — Blankwall renders 4 with the same id but only
      // the first has its modal/tooltip context wired up correctly.
      arBtn = document.querySelector('button[id="ar-button"]');
      return !!arBtn;
    }
    function position() {
      if (!arBtn || !visibleBtn || !visibleBtn.offsetParent) return;
      var r = visibleBtn.getBoundingClientRect();
      arBtn.style.cssText =
        'position: fixed !important;' +
        'top: ' + r.top + 'px !important;' +
        'left: ' + r.left + 'px !important;' +
        'width: ' + r.width + 'px !important;' +
        'height: ' + r.height + 'px !important;' +
        'opacity: 0 !important;' +
        'pointer-events: auto !important;' +
        'z-index: 11 !important;' +
        'clip: auto !important;' +
        'margin: 0 !important;' +
        'padding: 0 !important;' +
        'border: 0 !important;';
      arBtn.classList.add('cro-pdp-overlay__vir-clickthrough');
      // Hide all other Blankwall buttons (off-screen via default CSS still applies)
      document.querySelectorAll('button[id="ar-button"]').forEach(function(b) {
        if (b !== arBtn) b.classList.add('cro-vir-hidden-instance');
      });
    }
    function start() {
      if (!findAr()) {
        setTimeout(start, 500);
        return;
      }
      position();
      window.addEventListener('scroll', position, { passive: true });
      window.addEventListener('resize', position);
      // Re-position periodically (catches Blankwall reflow / async render)
      var ticks = 0;
      var iv = setInterval(function() {
        position();
        if (++ticks >= 10) clearInterval(iv);
      }, 500);
    }
    start();
  }

  function setupHeart(overlay) {
    var heartBtn = overlay.querySelector('[data-cro-heart]');
    if (!heartBtn) return;
    var productId = overlay.getAttribute('data-product-id');
    if (!productId) return;
    var slot = document.querySelector('.kl-hub-favorites-slot[data-product-id="' + productId + '"]');
    if (!slot) {
      setTimeout(function() { setupHeart(overlay); }, 500);
      return;
    }

    function getKlaviyoButton() {
      return slot.querySelector('.kl-hub-favorites-widget, button[class*="favoritesButton"]');
    }
    function syncState() {
      var kBtn = getKlaviyoButton();
      if (!kBtn) return;
      var icon = kBtn.querySelector('.kl-hub-wishlist-icon');
      var classNames = (icon && icon.className) || '';
      var btnClasses = kBtn.className || '';
      // Try several signals — Klaviyo may use different markers depending on version
      var isActive = (
        classNames.indexOf('--active') > -1 ||
        classNames.indexOf('Filled') > -1 ||
        classNames.indexOf('FilledHeart') > -1 ||
        btnClasses.indexOf('--active') > -1 ||
        btnClasses.indexOf('Active') > -1 ||
        kBtn.getAttribute('aria-pressed') === 'true' ||
        kBtn.getAttribute('data-active') === 'true'
      );
      // Negative signal: explicit --inactive class means we know it's inactive
      var isExplicitlyInactive = classNames.indexOf('--inactive') > -1;
      if (isExplicitlyInactive) isActive = false;
      heartBtn.classList.toggle('is-active', !!isActive);
    }

    syncState();
    // MutationObserver catches Klaviyo's class updates
    var observer = new MutationObserver(syncState);
    observer.observe(slot, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'aria-pressed', 'data-active']
    });
    // Polling fallback for first 5s after load (catches Klaviyo's late state push)
    var polls = 0;
    var pollInterval = setInterval(function() {
      syncState();
      if (++polls >= 10) clearInterval(pollInterval);
    }, 500);

    heartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var kBtn = getKlaviyoButton();
      if (kBtn) kBtn.click();
      // Optimistic toggle for immediate UX feedback; re-sync after Klaviyo updates
      heartBtn.classList.toggle('is-active');
      setTimeout(syncState, 400);
      setTimeout(syncState, 1200);
    });
  }

  function setupOverlay(overlay) {
    if (overlay.dataset.croInitialized === '1') return;
    overlay.dataset.croInitialized = '1';
    setupCounter(overlay);
    setupVir(overlay);
    setupHeart(overlay);
  }

  function init() {
    document.querySelectorAll('[data-cro-overlay]').forEach(setupOverlay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ── CRO-E-OVERLAY-V2-JS-END ── */



























/* ── CRO-G-HEADER-JS-START — scroll-state class toggle ── */
/* Tier 1 item G — chat-icon launcher → force Chat tab on hub open.
   We restyled .kl-hub-launcher as a chat FAB; clicking it should land the
   user on the Chat tab regardless of which tab was last viewed. After the
   click, poll the hub's tablist (rendered async) for the "Chat" tab and
   click it if it isn't already active. Bails after 3s. */
(function() {
  if (!document) return;
  document.addEventListener('click', function(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var launcher = t.closest('.kl-hub-launcher, [class*="HubLauncherWidget"] button');
    if (!launcher) return;
    var attempts = 0;
    var iv = setInterval(function() {
      attempts++;
      var tabs = document.querySelectorAll('.kl-hub-tabs__tablist button[role="tab"], .kl-hub-tabs button[role="tab"]');
      var chat = null;
      for (var i = 0; i < tabs.length; i++) {
        if ((tabs[i].textContent || '').trim() === 'Chat') { chat = tabs[i]; break; }
      }
      if (chat) {
        if (!chat.classList.contains('kl-hub-tab--active')) chat.click();
        clearInterval(iv);
      } else if (attempts > 30) {
        clearInterval(iv);
      }
    }, 100);
  }, true);
})();
/* ── CRO-G-HEADER-JS-END ── */















/* ── CRO-DRAWER-JS-START — generic drawer + reviews integration ── */
/* Tier 1 item H — generic drawer behaviour + reviews specific. */
(function() {
  // ── Generic drawer open/close ──────────────────────────────────────────
  function openDrawer(id) {
    var drawer = document.querySelector('[data-cro-drawer="' + id + '"]');
    if (!drawer) return null;
    drawer.removeAttribute('hidden');
    // force reflow so transition fires
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.body.classList.add('cro-drawer-open');
    drawer.dispatchEvent(new CustomEvent('cro:drawer:open', { detail: { id: id } }));
    return drawer;
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('cro-drawer-open');
    setTimeout(function() {
      if (!drawer.classList.contains('is-open')) drawer.setAttribute('hidden', '');
    }, 280);
  }

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest && e.target.closest('[data-cro-drawer-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer(trigger.getAttribute('data-cro-drawer-trigger'));
      return;
    }
    var close = e.target.closest && e.target.closest('[data-cro-drawer-close]');
    if (close) {
      e.preventDefault();
      closeDrawer(close.closest('[data-cro-drawer]'));
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-cro-drawer].is-open');
    if (open) closeDrawer(open);
  });

  // ── Reviews-specific integration ──────────────────────────────────────
  function setupReviewsDrawer() {
    var drawer = document.querySelector('[data-cro-drawer="reviews"]');
    if (!drawer) return;
    var contentEl = drawer.querySelector('[data-cro-drawer-content]');
    var loadingEl = drawer.querySelector('[data-cro-reviews-loading]');
    var fallbackEl = drawer.querySelector('[data-cro-reviews-fallback]');

    // Star widget click → open reviews drawer instead of jumping
    var starWidgets = document.querySelectorAll('.klaviyo-star-rating-widget');
    starWidgets.forEach(function(w) {
      // Wrap in capture-phase listener to beat Klaviyo's own jump handler
      w.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openDrawer('reviews');
      }, true);
    });

    // First-open: try to move Klaviyo's existing product reviews widget into drawer
    var moved = false;
    drawer.addEventListener('cro:drawer:open', function() {
      if (moved) return;
      // Klaviyo product reviews app block — find first instance not already moved
      var productReviewsBlock = document.querySelector('[id*="klaviyo_reviews_product_reviews"]');
      if (productReviewsBlock && !drawer.contains(productReviewsBlock)) {
        if (loadingEl) loadingEl.setAttribute('hidden', '');
        contentEl.appendChild(productReviewsBlock);
        moved = true;
        // After a moment, check if it has any review items
        setTimeout(function() { checkFallback(productReviewsBlock); }, 1500);
      } else if (!productReviewsBlock) {
        // No widget at all → show fallback immediately
        if (loadingEl) loadingEl.setAttribute('hidden', '');
        if (fallbackEl) fallbackEl.removeAttribute('hidden');
      }
    });

    function checkFallback(block) {
      // Heuristic: if the rendered widget has no list items / review entries, show fallback
      var hasReviews = block.querySelectorAll('[class*="review-item"], [class*="ReviewItem"], li[class*="review"], article[class*="review"]').length > 0;
      // Also check text content as a backup
      var text = (block.textContent || '').toLowerCase();
      var emptyIndicators = ['no reviews', 'be the first', 'leave a review'];
      var looksEmpty = !hasReviews || emptyIndicators.some(function(s) { return text.indexOf(s) > -1 && text.length < 500; });
      if (looksEmpty && fallbackEl) {
        fallbackEl.removeAttribute('hidden');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupReviewsDrawer);
  } else {
    setupReviewsDrawer();
  }
})();
/* ── CRO-DRAWER-JS-END ── */



/* ── CRO-CHEVRONS-JS-START — vanilla prev/next chevron handler ── */
/* Wires #prev-slide / #next-slide chevron buttons (rendered in
   snippets/product-gallery.liquid) to the theme's <scroll-carousel> custom
   element via its native next() / previous() methods. v2 (2026-05-04):
   uses scroll-carousel.next/previous() directly rather than simulating a
   dot click, which avoided a custom-element upgrade timing issue (dots
   inside <carousel-navigation> sometimes weren't in the DOM yet at
   DOMContentLoaded, so an init that closed over dots=[] would silently
   no-op). The methods are looked up at click time so timing doesn't
   matter. */
(function() {
  function getCarousel() {
    return document.querySelector('scroll-carousel.product-gallery__carousel') || document.querySelector('scroll-carousel');
  }
  function init() {
    var prev = document.getElementById('prev-slide');
    var next = document.getElementById('next-slide');
    if (!prev && !next) return;
    if (prev) prev.addEventListener('click', function() {
      var c = getCarousel();
      if (c && typeof c.previous === 'function') c.previous();
    });
    if (next) next.addEventListener('click', function() {
      var c = getCarousel();
      if (c && typeof c.next === 'function') c.next();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ── CRO-CHEVRONS-JS-END ── */




/* ── CRO-STORY-NAV-DEDUP-JS-START 2026-05-15 ── */
/* Generic controller for sections/storyNav.liquid — centralised here so
   each section instance ships zero inline controller bytes. Attaches to
   any section[id^="stories-"] present on the page. */
(function() {
  if (window.__abStoryNavInit) return;
  window.__abStoryNavInit = true;
  function step(track) {
    var item = track.querySelector('.stories-carousel__item');
    return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0) : 120;
  }
  function init() {
    var wraps = document.querySelectorAll('section[data-story-nav]');
    if (!wraps.length) wraps = document.querySelectorAll('section[id^="stories-"]');
    wraps.forEach(function(wrap) {
      var track = wrap.querySelector('.stories-carousel__track');
      if (!track) return;
      var prev = wrap.querySelector('.stories-carousel__btn--prev');
      var next = wrap.querySelector('.stories-carousel__btn--next');
      if (prev) prev.addEventListener('click', function() { track.scrollBy({ left: -step(track) * 3, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function() { track.scrollBy({ left:  step(track) * 3, behavior: 'smooth' }); });
      if (wrap.dataset.alignment === 'right') {
        window.addEventListener('load', function() {
          try { track.scrollLeft = track.scrollWidth; } catch (e) {}
        });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ── CRO-STORY-NAV-DEDUP-JS-END ── */

/* ── CRO-INAPP-PROMPT-JS-START 2026-05-15 ── */
/* In-app browser nudge: Instagram / Facebook / TikTok / Pinterest /
   Snapchat / LinkedIn / Line / Threads in-app webviews have buggy
   Shop Pay + payment-sheet flows. Show a small banner suggesting the
   system browser. Dismiss persists 24 h via localStorage. */
(function() {
  if (window.__abInAppPromptInit) return;
  window.__abInAppPromptInit = true;
  var ua = (navigator.userAgent || '');
  var inApp = /(Instagram|FBAN|FBAV|Barcelona|BytedanceWebview|musical_ly|TikTok|Pinterest|Snapchat|LinkedIn|Line\/)/i.test(ua);
  if (!inApp) return;
  try {
    var dismissed = localStorage.getItem('ab_inapp_prompt_dismissed_until');
    if (dismissed && Date.now() < parseInt(dismissed, 10)) return;
  } catch (_) {}
  var isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var browserLabel = isIOS ? 'Safari' : 'Chrome';
  var menuIcon = isIOS ? '⋯' : '⋮'; // horizontal vs vertical ellipsis
  function build() {
    var bar = document.createElement('div');
    bar.id = 'ab-inapp-prompt';
    bar.setAttribute('role', 'status');
    bar.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:9999;background:#1a1a1a;color:#fff;font:13px/1.4 system-ui,-apple-system,sans-serif;padding:10px 44px 10px 14px;text-align:center;box-shadow:0 1px 3px rgba(0,0,0,.2);';
    bar.innerHTML = 'For the smoothest checkout, tap <strong>' + menuIcon + '</strong> &rarr; <strong>Open in ' + browserLabel + '</strong>';
    var dismiss = document.createElement('button');
    dismiss.setAttribute('aria-label', 'Dismiss');
    dismiss.textContent = '✕';
    dismiss.style.cssText = 'position:absolute;top:6px;right:8px;background:none;border:0;color:#fff;font-size:16px;line-height:1;padding:6px 8px;cursor:pointer;';
    dismiss.addEventListener('click', function() {
      try { localStorage.setItem('ab_inapp_prompt_dismissed_until', String(Date.now() + 86400000)); } catch (_) {}
      bar.remove();
      document.body.style.marginTop = '';
    });
    bar.appendChild(dismiss);
    document.body.insertBefore(bar, document.body.firstChild);
    // Push page content down by banner height so it doesn't overlap fixed header
    requestAnimationFrame(function() {
      var h = bar.offsetHeight;
      document.body.style.marginTop = h + 'px';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
/* ── CRO-INAPP-PROMPT-JS-END ── */